import { render } from "./LockEmail.vue?vue&type=template&id=1c299cd8"
import script from "./LockEmail.vue?vue&type=script&lang=js"
export * from "./LockEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__